import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CouplingCantonEditingDialog from '../DialogEditingType/CouplingCantonEditingDialog';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';
import { COUPLING, COUPLING_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import DialogCouplingFoto from '../DialogFoto/DialogCouplingFoto';
import { fetchCouplingFileCount } from '../CountFile/FileCount';
import { fetchCouplingConnectionCount } from '../CountFile/ConnectionCount';


const CouplingCantonDialog = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
       handleCloseSnackbar, copyToClipboard, role, user, groupedCoordinatesWithColorTypeAndWidth,
       wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, cantonCouplingRefresh, setIsComponentСhangeCoorCoupling, territoryList }) => {

 

 const [openModalEditing, setOpenModalEditing] = useState(false);
 const [openModalDescription, setOpenModalDescription] = useState(false);
 const [openModalFoto, setOpenModalFoto] = useState(false);
 const [fileCount, setFileCount] = useState(0);
 const [connectionCount, setConnectionCount] = useState(0);

 const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
       setOpenModalDescription(true);
    }   
 }; 

 const openModalFotoFile = () => {
  if(fileCount != 0){
    setOpenModalFoto(true);
  }
 }; 

 const openModalEditingContent = () => {
    setOpenModalEditing(true);
 }; 
 
 
 useEffect(() => {
  const updateFileCount = async () => {  
    const count = await fetchCouplingFileCount(content.id);
    if (count !== null) {
      setFileCount(count); 
    }
  };
  updateFileCount();
});

useEffect(() => {
  const updateConnectionCount = async () => {  
    const count = await fetchCouplingConnectionCount(content.id);
    if (count !== null) {
      setConnectionCount(count); 
    }
  };
  updateConnectionCount();
});

  return (
    <Dialog open={open} className="dialogStyle">
    <DialogContent>
  
    {content.rankComponentId === 1 || content.rankComponentId === 2 ? (
           <img src='./сoupling.png' width='30' height='30' style={{ marginRight: "5px" }} />
            ) : (
            <img src='./coupling_canton.png' width='30' height='30' style={{ marginRight: "5px" }} />
          )}

    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #070707ff'}}>Муфта</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #131313ff' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "муфта"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #131313ff' }}>{content.city}</span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Муфта: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #0f0f0fff' }}>{content.couplingName}</span> </label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Мax ранг линка: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #1a1a1aff' }}>{content.rankComponentName}</span> </label>
      <br/>
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e' ,textShadow: '2px 2px 4px #131313ff'}}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean)
             .join(', ') || ' Нет'}
           </span>
        </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #141414ff' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #1b1b1bff' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #1a1a1aff' }}>{content.description}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #161616ff'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
        </button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <button onClick={openModalFotoFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px #2b2b2bff'}}>
        Просмотр файлов
        <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
           {fileCount > 0 ? fileCount : 'нет'}
        </span>
      </button>   

      <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
    {/* {((user === content.authorId && (role.role === ROLE_ENGINNER || role.role === ROLE_SENIOR_MASTER )) || role.role === ROLE_ADMIN) && ( */}
      {(
            (
              (user === content.authorId &&
                (role.role === ROLE_ENGINNER || role.role === ROLE_MASTER)
              ) ||
              role.role === ROLE_ADMIN ||
              (role.role === ROLE_ENGINNER  && territoryList.includes(content.canton))
            )       
      ) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>
    {/* Snackbar */}
    <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={COUPLING}
          flag={COUPLING_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

      {/* Modal редактирование CouplingCanton*/}
      <CouplingCantonEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        user={user}
        cantonCouplingRefresh={cantonCouplingRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
      />       

        {/* Modal Foto*/}
        <DialogCouplingFoto
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}     
      />       
  </Dialog>
  );
}

export default CouplingCantonDialog;